import { IAppRoute } from "@App/types";
import { matchPath, useParams as useReactRouterParams } from "react-router";
import { useLocation } from "./useLocation";
import { useRoutes } from "./useRoutes";

export const useParams = (
  fragments: IAppRoute[]
): Record<string, string | undefined> => {
  const { pathname: currentPathname } = useLocation();
  const params = useReactRouterParams();
  const { route } = useRoutes();
  const paramsWithLocale =
    matchPath(route(fragments, { withLocale: true }), currentPathname)
      ?.params || {};
  const paramsWithoutLocale =
    matchPath(route(fragments, { withLocale: false }), currentPathname)
      ?.params || {};
  return { ...params, ...paramsWithLocale, ...paramsWithoutLocale };
};
